export default {
  validFromTo: 'Valid from {fromDate} to {toDate}.',
  validForAllVillas: 'Offer applies to all villa categories',
  suitableHoneymoon: 'BEST FOR HONEYMOONERS',
  pricesIn: 'Prices shown are in US Dollars',
};
